
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accueil-seconde-college",
      function () {
        return require("private-next-pages/accueil-seconde-college.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accueil-seconde-college"])
      });
    }
  